/* eslint-disable react-hooks/exhaustive-deps */
import { ChoiceGroup, IChoiceGroupOption, Stack, TextField } from "@fluentui/react";
import { useEffect, useState } from "react";
import { IIPercPeligroDetalle } from "../../../Interfaces/IIpercBase";
import HelpersIpercBase, { validaIntervalo, validaOpcion, _indicadorByChoiceKey } from "../../../utils/helpers/HelpersIpercBase";
import themeBase from "../../../utils/theme/themeBase";

interface EditarRiesgoProps {
    objetoDetalle: IIPercPeligroDetalle
    getObjetoPUT: React.Dispatch<React.SetStateAction<IIPercPeligroDetalle>>
}

const EditarRiesgo: React.FunctionComponent<EditarRiesgoProps> = (props) => {
    const [peligroModel, setPeligroModel] = useState<IIPercPeligroDetalle>(props.objetoDetalle);

    let _riesgo_value = parseInt(peligroModel.riegos.evaluaciones.valor)
    let _medida_value = parseInt(peligroModel.medidas.evaluaciones.valor)

    const [choiceRiesgoKey, setChoiceRiesgoKey] = useState(peligroModel.riegos.evaluaciones.codigo);
    const [choiceMedidaKey, setChoiceMedidaKey] = useState(peligroModel.medidas.evaluaciones.codigo);

    const [RiesgoInd, setRiesgoInd] = useState<number>(_riesgo_value);
    const [medidaInd, setMedidaInd] = useState<number>(_medida_value);

    const _handleTexfileNumberRiesgoChange = ({ target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        const { name, value } = target as HTMLInputElement;
        let ind = validaIntervalo(parseInt(value))
        setRiesgoInd(ind)
        setChoiceRiesgoKey(validaOpcion(ind))

        setPeligroModel({
            ...peligroModel, riegos: {
                ...peligroModel.riegos, evaluaciones: {
                    ...peligroModel.riegos.evaluaciones,
                    valor: !isNaN(ind) ? ind.toString() : "1", codigo: validaOpcion(ind), id: validaOpcion(ind)
                }
            }
        })
    };
    const _handleTexfileNumberMedidaChange = ({ target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        const { name, value } = target as HTMLInputElement;
        let ind = validaIntervalo(parseInt(value))
        setMedidaInd(ind)
        setChoiceMedidaKey(validaOpcion(ind))
        setPeligroModel({
            ...peligroModel, medidas: {
                ...peligroModel.medidas, evaluaciones: {
                    ...peligroModel.medidas.evaluaciones,
                    valor: !isNaN(ind) ? ind.toString() : "1", codigo: validaOpcion(ind), id: validaOpcion(ind)
                }
            }
        })
    };

    const _onChangeRiesgoChoice = (e, option?: IChoiceGroupOption) => {
        if (option) {
            setChoiceRiesgoKey(option.key)
            setRiesgoInd(_indicadorByChoiceKey(option.key))
            setPeligroModel({
                ...peligroModel, riegos: {
                    ...peligroModel.riegos, evaluaciones: {
                        ...peligroModel.riegos.evaluaciones,
                        codigo: option.key, id: option.key, valor: _indicadorByChoiceKey(option.key).toString()
                    }
                }
            })
        }
    }
    const _onChangeMedidaChoice = (e, option?: IChoiceGroupOption) => {
        if (option) {
            setChoiceMedidaKey(option.key)
            setMedidaInd(_indicadorByChoiceKey(option.key))
            setPeligroModel({
                ...peligroModel, medidas: {
                    ...peligroModel.medidas, evaluaciones: {
                        ...peligroModel.medidas.evaluaciones,
                        codigo: option.key, id: option.key, valor: _indicadorByChoiceKey(option.key).toString()
                    }
                }
            })
        }
    }

    useEffect(() => {
        // console.log("PUT R: ", peligroModel.riegos.evaluaciones)
        // console.log("PUT M: ", peligroModel.medidas.evaluaciones)
        props.getObjetoPUT({ ...peligroModel })
    }, [peligroModel]);

    return (
        <>
            <div className="ms-Grid-col ms-lg12">
                <br />
                <TextField
                    resizable={false}
                    style={themeBase.borderSmoke}
                    label="Peligro"
                    name="peligro"
                    required
                    onChange={(e, value) => {
                        setPeligroModel({ ...peligroModel, nombre: value! })
                    }}
                    value={peligroModel.nombre}
                    borderless
                // prefix="Peligro"
                />
            </div>
            <br />
            <br />
            <div className="ms-Grid-col ms-lg12">
                <TextField
                    {...HelpersIpercBase.TextFieldMultilineProps}
                    label="Riesgo"
                    name="nombre"
                    borderless
                    value={peligroModel.riegos.nombre}
                    onChange={(e, value) => {
                        setPeligroModel({
                            ...peligroModel, riegos: {
                                ...peligroModel.riegos, nombre: value!
                            }
                        })
                    }}
                />
                <Stack verticalAlign="end" horizontal className="ms-depth-4 ms-bgColor-gray10" padding={8}>
                    <div className="ms-Grid-col ms-lg6">
                        <ChoiceGroup
                            name="riesgo"
                            selectedKey={choiceRiesgoKey}
                            onChange={_onChangeRiesgoChoice}
                            options={HelpersIpercBase.IPERC_CHOICE_OPTIONS}
                            styles={{ flexContainer: { display: 'flex' } }}
                        />
                    </div>
                    <div className="ms-Grid-col ms-lg6 ">
                        <TextField
                            {...HelpersIpercBase.TextFieldNumberProps}
                            id='riesgo'
                            name="indicador"
                            value={RiesgoInd.toString()}//riegoModel.riegos.evaluaciones.valor
                            onChange={_handleTexfileNumberRiesgoChange}
                            onBlur={() => { if (isNaN(RiesgoInd)) setRiesgoInd(1) }}
                        />
                    </div>
                </Stack>
            </div>
            <br />
            <br />
            <div className="ms-Grid-col ms-lg12">
                <TextField
                    {...HelpersIpercBase.TextFieldMultilineProps}
                    label="Medida Control"
                    name="nombre"
                    value={peligroModel.medidas.nombre}
                    onChange={(e, value) => {
                        setPeligroModel({
                            ...peligroModel,
                            medidas: { ...peligroModel.medidas, nombre: value! }
                        })
                    }}
                />
                <Stack verticalAlign="end" horizontal className="ms-depth-4 ms-bgColor-gray10" padding={8}>
                    <div className="ms-Grid-col ms-lg6">
                        <ChoiceGroup
                            name="medida"
                            selectedKey={choiceMedidaKey}
                            onChange={_onChangeMedidaChoice}
                            options={HelpersIpercBase.IPERC_CHOICE_OPTIONS}
                            styles={{ flexContainer: { display: 'flex' } }}
                        />
                    </div>
                    <div className="ms-Grid-col ms-lg6">
                        <TextField
                            {...HelpersIpercBase.TextFieldNumberProps}
                            id='medida'
                            name="indicador"
                            value={medidaInd.toString()}//peligroModel.medidas.evaluaciones.valor
                            onChange={_handleTexfileNumberMedidaChange}
                            onBlur={() => { if (isNaN(medidaInd)) setMedidaInd(1) }}
                        />
                    </div>
                </Stack>
            </div>
        </>
    );
}

export default EditarRiesgo;

